import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureComponent } from './feature.component';

const components = [FeatureComponent];

@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class FeatureModule {}
